"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { visibleNavGroups } from "./nav-config";

/** 侧栏分组导航，按当前路径和角色过滤并高亮。 */
export function Sidebar({
  permissions = [],
  collapsed = false,
  admin = false,
}: {
  permissions?: string[];
  collapsed?: boolean;
  admin?: boolean;
}) {
  const pathname = usePathname();

  const visibleGroups = visibleNavGroups(permissions, admin);

  const activeHref = visibleGroups
    .flatMap((group) => group.items)
    .filter((item) => pathname === item.href || pathname.startsWith(`${item.href}/`))
    .sort((left, right) => right.href.length - left.href.length)[0]?.href;

  return (
    <aside className="sidebar" aria-label="主导航">
      {visibleGroups.map((group, gi) => (
        <nav className={`nav${group.divided ? " nav-divided" : ""}`} key={gi}>
          {group.title ? <div className="nav-group">{group.title}</div> : null}
          {group.items.map((item) => {
            const active = item.href === activeHref;
            return (
              <Link
                key={item.href}
                href={item.href}
                className={active ? "active" : undefined}
                title={collapsed ? item.label : undefined}
                aria-label={collapsed ? item.label : undefined}
              >
                {item.icon}
                <span className="nav-label">{item.label}</span>
              </Link>
            );
          })}
        </nav>
      ))}
    </aside>
  );
}
